import React from 'react';
import { Routes, Route, HashRouter, Navigate } from 'react-router-dom';
import { rutas } from './services/routes';
import './App.css';

function App() {
  return (
    <HashRouter>
      <div className="App">
        <Routes>
          <Route path="/" element={<Navigate to="/Login" />} />
          
          {rutas.map((route, index) => (
            <Route key={index} path={route.ruta} element={route.component} />
          ))}
        </Routes>
      </div>
    </HashRouter>
  );
}

export default App;
